var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent, Fragment } from "react";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import RewardWalletTransactionQuery from "@irati/wallet/apollo/query/RewardWalletTransactions";
import authentication from "@irati/auth";
import Loader from "@irati/utils/services/apollo/Loading/Loader";
import groupByDate from "@irati/wallet/helpers/groupWalletItemsByDate";
import RewardWalletBalanceQuery from "@irati/wallet/apollo/query/RewardWallet";
import getId from "@irati/utils/id";
import rewardWalletTracking from "@irati-tracking/wallet/rewardWallet";
import { StatementItem, Hr, ShowMoreButton } from "../StatementItems";
import DateHeader from "../DateHeader";
import NoData from "../NoData";
import { Container } from "../Transactions/styled";
var RewardWalletTransactions = /** @class */ (function (_super) {
    __extends(RewardWalletTransactions, _super);
    function RewardWalletTransactions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RewardWalletTransactions.prototype.hasReceivedData = function (data) {
        return data &&
            ("rewardStatementItems" in data) &&
            ("results" in data.rewardStatementItems) &&
            (data.rewardStatementItems.results.length > 0);
    };
    RewardWalletTransactions.prototype.render = function () {
        var _this = this;
        var _a = this.props, formatMessage = _a.formatMessage, id = _a.id;
        var idNamespace = getId("transactions", this.props);
        return (React.createElement(Container, null,
            React.createElement(RewardWalletBalanceQuery, null, function (_a) {
                var walletData = _a.data;
                var variables = {
                    tenantId: authentication.userTenant().uuid,
                    userId: authentication.user().uuid,
                    walletId: walletData.rewardWallet.uuid,
                    limit: 15
                };
                return (React.createElement(RewardWalletTransactionQuery, { variables: variables }, function (_a) {
                    var transactionData = _a.data, fetchMore = _a.fetchMore, isLoading = _a.loading, networkStatus = _a.networkStatus;
                    var hasData = _this.hasReceivedData(transactionData);
                    var groupedData = hasData ? groupByDate([], transactionData.rewardStatementItems.results) : [];
                    var isRefetching = networkStatus === 3;
                    var variablesToSend = hasData ? __assign(__assign({}, variables), { cursor: transactionData.rewardStatementItems.results[transactionData.rewardStatementItems.results.length - 1].uuid }) : variables;
                    return isLoading && !isRefetching ? React.createElement(Loader, null) : (React.createElement(Fragment, null,
                        hasData && groupedData.results.map(function (_a) {
                            var data = _a.data, date = _a.date;
                            var key = date.format("YYYY-MM-DD");
                            return (React.createElement(Fragment, { key: key },
                                React.createElement(Hr, null),
                                React.createElement(DateHeader, { id: getId("date-header_" + key, idNamespace), date: date }),
                                data.map(function (statementItem) { return (React.createElement(StatementItem, { id: getId("statement-item_" + statementItem.uuid, idNamespace), isRewardWallet: true, statementItem: statementItem, key: statementItem.uuid })); })));
                        }),
                        isLoading && React.createElement(Loader, null),
                        hasData && transactionData.rewardStatementItems.hasMore && !isLoading &&
                            React.createElement(ShowMoreButton, { id: idNamespace, onClick: function () {
                                    rewardWalletTracking.clickRewardShowMore();
                                    fetchMore(variablesToSend);
                                } },
                                React.createElement(FormattedMessage, { id: "wallet.statementItems.rewardWallet.showMoreButton.text" })),
                        !isLoading && !hasData &&
                            React.createElement(NoData, { useCardStyle: true, id: id, text: formatMessage({ id: "wallet.reward.noScheduledTransfers.text" }) })));
                }));
            })));
    };
    return RewardWalletTransactions;
}(PureComponent));
export default injectIntl(RewardWalletTransactions);
